/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class SlackService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any No response body
     * @throws ApiError
     */
    public slackEventsCreate(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/slack/events/',
        });
    }

}
